"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamStandings = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const material_2 = require("@mui/material");
const react_1 = __importStar(require("react"));
const icons_material_1 = require("@mui/icons-material");
const LeaderboardContext_1 = require("../Context/LeaderboardContext");
const LeaderBoardTeams_1 = require("./LeaderBoardTeams");
const TeamsLogicFunctions_1 = require("../Functions/TeamsLogicFunctions");
const courseDataHelpers_1 = require("../Utils/courseDataHelpers");
const LeaderboardViewPaper_1 = require("./LeaderboardViewPaper");
const ScrollableFadeOverlay_1 = require("./ScrollableFadeOverlay");
const stablefordUtils_1 = require("../Functions/stablefordUtils");
const useLeaderboardDisplayFlags_1 = require("../Hooks/useLeaderboardDisplayFlags");
const useEventDisplayFlags_1 = require("../Hooks/useEventDisplayFlags");
const groupAndRankByDivisionFlight_1 = require("../Functions/groupAndRankByDivisionFlight");
const seriesPointsUtils_1 = require("../Functions/seriesPointsUtils");
const seriesPointsDebug_1 = require("../Functions/seriesPointsDebug");
const individualLeaderboardGridSx_1 = require("./StackStyles/individualLeaderboardGridSx");
function inferImpliedScope(row, scoreRank, pointsRank, divRank, divisionPeerCount, totalField) {
    if ((row.adminRank ?? 0) > 0 && divisionPeerCount > 0 && (row.adminRank ?? 0) <= totalField / 2 && pointsRank !== row.adminRank) {
        return 'field-or-slice';
    }
    if (divRank != null && scoreRank !== divRank)
        return 'flight-local';
    if (scoreRank !== pointsRank)
        return 'division-recomputed';
    return 'aligned';
}
const TeamStandings = ({ leaderboardData, courseData, roundValue, stackRef }) => {
    const { factor, appTheme, standingTabs, windowSize, leaderboardScoreFormat, isPWA, isHeadless, hideSelector, currentRound, eventData, bottomPadding, seriesPoints } = (0, LeaderboardContext_1.useLeaderboardContext)();
    const [localTeamsData, setLocalTeamsData] = react_1.default.useState(null);
    const [paperPosition, setPaperPosition] = (0, react_1.useState)({ top: 0 });
    const [teeSetData, setTeeSetData] = (0, react_1.useState)(null);
    const [fadeIn, setFadeIn] = (0, react_1.useState)(false);
    const { hasTeamPlayoffWinner } = (0, useLeaderboardDisplayFlags_1.useLeaderboardDisplayFlags)({ eventData, leaderboardData });
    const isStablefordRound = (0, stablefordUtils_1.isStablefordPlayType)(eventData?.rounds?.[roundValue - 1]?.playType);
    const currentRoundData = eventData?.rounds?.[roundValue - 1];
    const isSeriesRound = currentRoundData?.pointSystem === 'Series' && currentRoundData?.useSeriesPointsForTeams && !!seriesPoints;
    const { hasDivisions, hasFlights } = (0, useEventDisplayFlags_1.useEventDisplayFlags)({ eventData, localRoundValue: roundValue });
    const pointsRankMap = (0, react_1.useMemo)(() => {
        if (!leaderboardData?.length)
            return {};
        return (0, seriesPointsUtils_1.buildDivisionScopedPointsRankMap)(leaderboardData, hasDivisions, isStablefordRound);
    }, [leaderboardData, hasDivisions, isStablefordRound]);
    // Build a map of eventScore _id → division rank for non-series display grouping
    const divisionRankMap = (0, react_1.useMemo)(() => {
        if ((!hasDivisions && !hasFlights) || !leaderboardData?.length)
            return undefined;
        const groups = (0, groupAndRankByDivisionFlight_1.groupAndRankByDivisionFlight)({
            leaderboardData,
            flighting: eventData?.flighting,
            isStableford: isStablefordRound,
        });
        const map = {};
        for (const divGroup of groups) {
            for (const flightGroup of divGroup.flights) {
                for (const row of flightGroup.rows) {
                    if (row._id != null) {
                        map[row._id.toString()] = row.rank;
                    }
                }
            }
        }
        return map;
    }, [hasDivisions, hasFlights, leaderboardData, eventData?.flighting, isStablefordRound]);
    (0, react_1.useEffect)(() => {
        if (!isSeriesRound || !leaderboardData?.length)
            return;
        const divisionCounts = new Map();
        for (const row of leaderboardData) {
            const div = row.playerInfo?.[0]?.division ?? '';
            divisionCounts.set(div, (divisionCounts.get(div) ?? 0) + 1);
        }
        const mismatches = [];
        let playoffCount = 0;
        for (const row of leaderboardData) {
            const id = row._id?.toString();
            if (!id)
                continue;
            const scoreRank = row.rank ?? 0;
            const pointsRank = pointsRankMap[id] ?? scoreRank;
            const divRank = divisionRankMap?.[id];
            const division = row.playerInfo?.[0]?.division ?? '';
            const divisionPeerCount = divisionCounts.get(division) ?? 0;
            if (row.adminRank > 0 || row.indPlayoffWin)
                playoffCount++;
            if (scoreRank !== pointsRank ||
                (divRank != null && divRank !== pointsRank) ||
                row.adminRank > 0) {
                if (mismatches.length < 15) {
                    mismatches.push({
                        name: row.playerName,
                        division,
                        flight: row.playerInfo?.[0]?.flight ?? '',
                        scoreRank,
                        divRank,
                        pointsRank,
                        adminRank: row.adminRank ?? 0,
                        divisionPeerCount,
                        impliedScope: inferImpliedScope(row, scoreRank, pointsRank, divRank, divisionPeerCount, leaderboardData.length),
                    });
                }
            }
        }
        (0, seriesPointsDebug_1.logSeriesPoints)('scopeCheck', {
            hasDivisions,
            hasFlights,
            playerCount: leaderboardData.length,
            playoffCount,
            mismatches,
        });
    }, [isSeriesRound, leaderboardData, pointsRankMap, divisionRankMap, hasDivisions, hasFlights]);
    const roundCourseID = eventData?.rounds?.[roundValue - 1]?.courseID;
    const currentCourseData = (0, courseDataHelpers_1.getCourseById)(courseData, roundCourseID);
    (0, react_1.useEffect)(() => {
        if (standingTabs === 'teams') {
            setFadeIn(true);
        }
        else {
            setFadeIn(false);
        }
    }, [standingTabs]);
    (0, react_1.useEffect)(() => {
        if (leaderboardData.length > 0 && currentCourseData && standingTabs === 'teams') {
            const teeData = (0, courseDataHelpers_1.getTeeSetFromCourse)(currentCourseData, leaderboardData[0]?.playerInfo?.[0]?.teeSet);
            setTeeSetData(teeData);
            orderTeamsData();
        }
    }, [leaderboardData, courseData, standingTabs, leaderboardScoreFormat, roundValue, currentCourseData, pointsRankMap]);
    (0, react_1.useEffect)(() => {
        const timeoutId = setTimeout(() => {
            const dividerElement = document.getElementById('leaderboard-button-divider');
            if (dividerElement) {
                const rect = dividerElement.getBoundingClientRect();
                const topOffset = hideSelector ? 0 : (isHeadless ? 60 : (windowSize.appBarHeight ?? 70));
                setPaperPosition({ top: rect.bottom - topOffset + 5 * factor * 1.5 });
            }
        }, 0);
        return () => clearTimeout(timeoutId);
    }, [standingTabs, factor, isHeadless, hideSelector, windowSize.appBarHeight]);
    const orderTeamsData = () => {
        const normalizedPlayFormat = (eventData?.playFormat || '')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, ' ')
            .trim();
        const baseProps = {
            leaderboardData,
            courseData,
            currentRound: roundValue,
            setLocalTeamsData,
            leaderboardScoreFormat,
            eventData,
            seriesPoints,
            pointsRankMap,
        };
        if (normalizedPlayFormat === 'worst ball') {
            (0, TeamsLogicFunctions_1.TeamsLogic)('worstScoresByHole', baseProps);
        }
        else if (normalizedPlayFormat === 'best ball') {
            (0, TeamsLogicFunctions_1.TeamsLogic)('bestScoresByHole', baseProps);
        }
        else if (normalizedPlayFormat === 'high low') {
            (0, TeamsLogicFunctions_1.TeamsLogic)('highLowByHole', baseProps);
        }
        else if (normalizedPlayFormat === 'shamble') {
            (0, TeamsLogicFunctions_1.TeamsLogic)('bestScoresByHole', baseProps);
        }
        else if (normalizedPlayFormat === 'best round') {
            (0, TeamsLogicFunctions_1.TeamsLogic)('bestRound', baseProps);
        }
        else {
            (0, TeamsLogicFunctions_1.TeamsLogic)('sumScores', baseProps);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(LeaderboardViewPaper_1.LeaderboardViewPaper, { viewType: "teams", standingTabs: standingTabs, paperPosition: paperPosition, fadeIn: fadeIn, windowSize: windowSize, isPWA: isPWA, factor: factor, children: [hasTeamPlayoffWinner && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: { width: '95%', display: 'flex', justifyContent: 'flex-start' }, children: (0, jsx_runtime_1.jsx)(material_2.Typography, { variant: "caption", sx: { mb: 0, fontStyle: 'italic', textAlign: 'left', width: '95%' }, children: "* Results of team playoff shown" }) })), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { ...individualLeaderboardGridSx_1.teamLeaderboardHeaderGridSx, ...individualLeaderboardGridSx_1.individualLeaderboardRowWidthSx, ...individualLeaderboardGridSx_1.individualLeaderboardContentInsetSx, mb: 1 }, children: [(0, jsx_runtime_1.jsx)(material_2.Typography, { fontWeight: "500", sx: { textAlign: 'center' }, children: "Rank" }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: individualLeaderboardGridSx_1.teamLeaderboardTeamCellSx, children: [(0, jsx_runtime_1.jsx)(icons_material_1.Verified, { sx: { color: 'transparent', display: 'inline', height: 15 * factor, flexShrink: 0 } }), (0, jsx_runtime_1.jsx)(material_2.Typography, { fontWeight: "500", sx: { textAlign: 'left' }, children: "Team" })] }), (0, jsx_runtime_1.jsx)(material_2.Typography, { fontWeight: "500", sx: { textAlign: 'center' }, children: "Thru" }), (0, jsx_runtime_1.jsx)(material_2.Typography, { fontWeight: "500", sx: { textAlign: 'center' }, children: isSeriesRound ? 'Pts' : isStablefordRound ? 'Points' : 'Score' })] }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { position: 'relative', width: '100%', flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }, children: [(0, jsx_runtime_1.jsx)(material_1.Stack, { direction: "column", spacing: 0, ref: stackRef, sx: {
                            width: '100%', overflowY: 'auto', overflowX: 'hidden', flex: 1,
                            paddingBottom: (0, LeaderboardContext_1.standingsScrollPaddingBottom)(bottomPadding),
                            ...individualLeaderboardGridSx_1.individualLeaderboardContentInsetSx,
                            WebkitOverflowScrolling: 'touch', minHeight: 0,
                        }, children: localTeamsData && localTeamsData.map((score, index) => ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: ((index > 0 && score.teamRank > localTeamsData[index - 1].teamRank) || (index === 0 && score.teamRank === 1)) && ((0, jsx_runtime_1.jsx)(material_1.Stack, { spacing: 0, sx: {
                                    ...individualLeaderboardGridSx_1.individualLeaderboardRowWidthSx,
                                    borderRadius: 1, padding: 0, cursor: 'pointer',
                                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
                                    boxShadow: '0 2px 1px -1px rgba(0,0,0,0.2), 0 1px 1px 0 rgba(0,0,0,0.14), 2px 0 2px 0 rgba(0,0,0,0.12)',
                                    opacity: 0,
                                    animation: `fadeIn 0.6s forwards`,
                                    '@keyframes fadeIn': {
                                        '0%': { opacity: 0, transform: 'translateY(5px)' },
                                        '100%': { opacity: 1, transform: 'translateY(0)' }
                                    },
                                }, children: localTeamsData.filter((item) => item.teamRank === score.teamRank).map((rankScore, rankIndex) => ((0, jsx_runtime_1.jsx)(material_1.Stack, { spacing: 0, sx: {
                                        width: '100%', borderRadius: 1, padding: 0, cursor: 'pointer',
                                        '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
                                    }, children: (0, jsx_runtime_1.jsx)(LeaderBoardTeams_1.LeaderboardTeams, { teamsLeaderboardData: rankScore, courseData: currentCourseData, teeSetData: teeSetData, index: 0, roundValue: roundValue, divisionRankMap: divisionRankMap, pointsRankMap: isSeriesRound ? pointsRankMap : undefined }) }, `team-${index}-rank-${rankIndex}`))) }, `score-${index}-rank-${score.teamRank}`)) }, `team-${score._id || index}`))) }), (0, jsx_runtime_1.jsx)(ScrollableFadeOverlay_1.ScrollableFadeOverlay, { stackRef: stackRef, dataDependency: localTeamsData })] })] }));
};
exports.TeamStandings = TeamStandings;
